// extracted by mini-css-extract-plugin
export const sectionSpacing = "footer-module--section-spacing--118hG";
export const rowSpacing = "footer-module--row-spacing--z618-";
export const rowSpacingSml = "footer-module--row-spacing-sml--GEmxM";
export const footer = "footer-module--footer--r5x7K";
export const sponsors = "footer-module--sponsors--PPcIe";
export const colabTitle = "footer-module--colabTitle--2Gc4I";
export const logoBofa = "footer-module--logoBofa--3aEFI";
export const logoCorfoMineduc = "footer-module--logoCorfoMineduc--VUi1v";
export const imgCorfo = "footer-module--imgCorfo--OS4j1";
export const imgGob = "footer-module--imgGob--2vBrW";
export const imgMineduc = "footer-module--imgMineduc--1kaO7";
export const footerRow = "footer-module--footerRow--2qqnL";
export const logoIng = "footer-module--logoIng--3CkhN";
export const socials = "footer-module--socials--2__zQ";
export const textBox = "footer-module--textBox--ByZdQ";
export const logoSanity = "footer-module--logoSanity--2UE0n";
export const subfooter = "footer-module--subfooter--PWCV_";